// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blue-dot {
  height: 25px;
  width: 25px;
  background-color: blue;
  border-radius: 50%;
  float: right;
  margin-left: 12px;
}

.green-dot {
  height: 25px;
  width: 25px;
  background-color: green;
  border-radius: 50%;
  float: right;
  margin-left: 12px;
}

.yellow-dot {
  height: 25px;
  width: 25px;
  background-color: yellow;
  border-radius: 50%;
  float: right;
  margin-left: 12px;
}

.red-dot {
  height: 25px;
  width: 25px;
  background-color: red;
  border-radius: 50%;
  float: right;
  margin-left: 12px;
}

.gray-dot {
  height: 25px;
  width: 25px;
  background-color: gray;
  border-radius: 50%;
  float: right;
  margin-left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/master-data/owners/owners-create/tabs/tab-agency/tab-agency.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":[".blue-dot {\n    height: 25px;\n    width: 25px;\n    background-color: blue;\n    border-radius: 50%;\n    float: right;\n    margin-left: 12px;\n}\n\n.green-dot {\n    height: 25px;\n    width: 25px;\n    background-color: green;\n    border-radius: 50%;\n    float: right;\n    margin-left: 12px;\n}\n\n.yellow-dot {\n    height: 25px;\n    width: 25px;\n    background-color: yellow;\n    border-radius: 50%;\n    float: right;\n    margin-left: 12px;\n}\n\n.red-dot {\n    height: 25px;\n    width: 25px;\n    background-color: red;\n    border-radius: 50%;\n    float: right;\n    margin-left: 12px;\n}\n\n.gray-dot {\n    height: 25px;\n    width: 25px;\n    background-color: gray;\n    border-radius: 50%;\n    float: right;\n    margin-left: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
